import * as React from "react";
import {Link, NavLink} from "react-router-dom";

interface FilterProps {
    items: Array<{
        title: string;
        counter: number;
        link: string;
        active?: boolean;
    }>
}

export const CardsFilters = (props: FilterProps) => {
    return <nav className="navbar">
        <ul className="nav nav-pills" style={{ width: '100%' }}>
            { props.items.map(item => (
                <li key={item.link} className="nav-item"><NavLink activeClassName={'active'} className={`nav-link`} to={item.link}>
                    { item.title } ({ item.counter })
                </NavLink></li>
            )) }
        </ul>
    </nav>
};
